import { ACTIONS, eventDetailVersion, activity } from '@uma/react-commons/dist';
import { ScreenName, ScreenPath } from 'src/utils/constants';

export const OrdersScreenDisplayed = {
  action: ACTIONS.SCREEN_DISPLAYED,
  activity,
  screenPath: ScreenPath,
  screenName: ScreenName,
  version: eventDetailVersion
};
